<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ mode === 'add' ? 'Nuevo Presupuesto' : 'Editar Presupuesto' }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content ion-padding">

  <!-- GENERAL VIEW (Summary Mode) -->
  <div class="header-card" *ngIf="mode === 'list' && !trabajoItemId && (items.length > 0 || headerData.id)">
    <ion-card class="summary-info-card">
      <ion-card-header>
        <ion-card-title>Información General</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="6">
              <div class="info-block">
                <span class="label">Cliente</span>
                <span class="value">{{trabajo?.cliente}}</span>
              </div>
            </ion-col>
            <ion-col size="6">
              <div class="info-block">
                <span class="label">Lugar</span>
                <span class="value">{{trabajo?.lugar}}</span>
              </div>
            </ion-col>
            <ion-col size="12">
              <div class="info-block scrollable-block">
                <span class="label">Items del Trabajo</span>
                <span class="value">{{jobItemsText}}</span>
              </div>
            </ion-col>
            <ion-col size="12">
              <div class="divider"></div>
            </ion-col>
            <!-- Editable Fields -->
            <ion-col size="6">
              <div class="input-group">
                <span class="field-label">Estado</span>
                <ion-item lines="none" class="modern-item">
                  <ion-select [(ngModel)]="headerData.estado" interface="popover">
                    <ion-select-option value="En Creación">En Creación</ion-select-option>
                    <ion-select-option value="Cotizar">Cotizar</ion-select-option>
                  </ion-select>
                </ion-item>
              </div>
            </ion-col>
            <ion-col size="6">
              <div class="input-group">
                <span class="field-label">Días Est.</span>
                <ion-item lines="none" class="modern-item">
                  <ion-input type="number" [(ngModel)]="headerData.dias"></ion-input>
                </ion-item>
              </div>
            </ion-col>
            <ion-col size="12">
              <div class="input-group">
                <span class="field-label">Notas Internas</span>
                <ion-item lines="none" class="modern-item textarea-item">
                  <ion-textarea rows="2" [(ngModel)]="headerData.notas"></ion-textarea>
                </ion-item>
              </div>
            </ion-col>

            <!-- Summary Text & Total -->
            <ion-col size="12">
              <div class="summary-box">
                <p class="summary-text">{{summaryText}}</p>
                <div class="total-display">
                  <span>Total Estimado:</span>
                  <span class="amount">${{totalBudget | number:'1.2-2'}}</span>
                </div>
              </div>
            </ion-col>

            <ion-col size="12" class="actions-col">
              <ion-button fill="outline" color="danger" size="small" (click)="deleteBudget()">
                <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
              </ion-button>
              <ion-button color="tertiary" size="small" (click)="updateHeader()">
                Actualizar Datos
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>
  </div>

  <!-- ITEM VIEW (List Mode) - Only show if trabajoItemId is present -->
  <div class="item-list" *ngIf="items.length > 0 && trabajoItemId">
    <div class="item-card clickable" *ngFor="let item of items" (click)="editItem(item)"
      [class.inactive-item]="!isActive(item)">
      <div class="card-left">
        <div class="icon-box">
          <ion-icon [name]="item.icon || 'help-circle-outline'"></ion-icon>
        </div>
        <div class="info">
          <h3>{{item.actividad}}</h3>

          <p *ngIf="item.tipo === 'MOBRA'">
            {{item.rol || 'Rol general'}}
            <span class="detail">{{item.cantidad}} pers.</span>
            <span class="detail">{{item.dias}} días</span>
          </p>
          <p *ngIf="item.tipo === 'MATERIAL'">
            Material
            <span class="detail">{{item.cantidad}} {{item.rol || 'un.'}}</span>
          </p>
          <p *ngIf="item.tipo === 'GASTO'">Gasto Vario</p>
          <p *ngIf="item.tipo === 'SUB'">Subcontrato</p>
          <p *ngIf="item.tipo === 'MEDIDA'">
            Medida
            <span class="detail">{{item.cantidad}} {{item.rol}}</span>
          </p>

          <p *ngIf="item.nota" style="font-size: 0.8rem; color: #7f8c8d; margin-top: 2px;">
            <ion-icon name="document-text-outline" style="vertical-align: middle;"></ion-icon> {{item.nota}}
          </p>
        </div>
      </div>
      <div class="card-right">
        <div class="toggle-wrapper" (click)="$event.stopPropagation()">
          <ion-toggle [checked]="isActive(item)" (ionChange)="toggleActive(item, $event)" color="success"
            style="transform: scale(0.8);"></ion-toggle>
        </div>
        <div class="total">${{item.total | number:'1.2-2'}}</div>
        <div class="subtext" *ngIf="item.tipo !== 'GASTO' && item.tipo !== 'SUB'">
          ${{item.precio || item.salario | number:'1.2-2'}}
          {{item.tipo === 'MOBRA' ? '/día' : '/un'}}
        </div>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="items.length === 0 && !loading">
    <ion-icon name="calculator-outline" style="font-size: 4rem; color: #ccc;"></ion-icon>
    <p style="color: #666; margin-top: 10px;">
      {{ mode === 'list' ? 'No hay items registrados' : 'Comienza agregando items al presupuesto' }}
    </p>
  </div>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="trabajoItemId">
    <ion-fab-button color="danger" (click)="presentAddOptions()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

</ion-content>
